// Generated from evals/results/tenants/eval-hak-hr/manifest.json — do not hand-edit.
//
// Ten proposals, four cleared. The six refusals carry the two commonest reasons in the
// corpus.
//
//
// Typed through one cast, and only one: the crawler emits `extract` objects shaped
// { "$root": "li", li: {…}, a: {…} }. That is valid against the zod schema in
// packages/manifest, but TypeScript cannot reconcile the literal `$root: string`
// member with the sibling index signature of ExtractField — a structural limitation
// of index signatures, not a defect in the data. Casting here is the alternative to
// forking a shared type, which is forbidden.
//
// Every value below was produced by a real crawl of the live site with LLM
// synthesis disabled (--no-llm). Nothing is invented, including the parts that
// do not flatter the pipeline.

import type { Manifest } from '@clawharbor/manifest';

export const HAK_MANIFEST: Manifest = {
  "$schema": "https://clawharbor.io/schema/manifest/v1.json",
  "manifestVersion": "1.0.0",
  "id": "hak-hr",
  "generatedAt": "2026-08-27T22:15:58.980Z",
  "generator": {
    "name": "clawharbor",
    "version": "0.1.0",
    "mode": "assisted"
  },
  "source": {
    "inputUrl": "https://www.hak.hr/",
    "canonicalOrigin": "https://www.hak.hr",
    "redirectChain": [
      "https://www.hak.hr/"
    ],
    "platform": {
      "rendering": "server"
    },
    "robots": {
      "fetchedAt": "2026-08-27T22:15:33.542Z",
      "disallowAll": false,
      "rules": [],
      "sitemaps": [
        "https://www.hak.hr/sitemap.xml"
      ]
    },
    "crawl": {
      "userAgent": "ClawHarborBot/1.0 (+https://clawharbor.io/bot)",
      "pages": 8,
      "maxRps": 0.5
    }
  },
  "identity": {
    "displayName": "www.hak.hr",
    "locale": "hr",
    "altLocales": [],
    "timezone": "UTC",
    "currency": "EUR",
    "contact": {},
    "logo": {
      "url": "https://static.1987.hr/hakweb/images/icons/hak-logo-square-512px.png",
      "kind": "png",
      "source": "link:apple-touch-icon",
      "usage": "reference-only"
    },
    "wordmark": {
      "text": "www.hak.hr",
      "case": "asIs"
    }
  },
  "brand": {
    "mode": "dark",
    "palette": {
      "brand.primary": {
        "evidence": [
          "cta-background:.cookies-eu .cookies-eu-button-holder .cookies-eu-ok occurrences:5",
          "cta-background:.membership-type-button, .membership-close-button occurrences:27",
          "cta-background:.membership-close-button.disabled occurrences:27",
          "score=0.79 chroma=0.098 gate=1.00 sources=state-hint+cta-background+accent-border+area-residue+surface-background+link-color"
        ],
        "confidence": 0.7,
        "derived": false,
        "value": "#4b87b8",
        "oklch": "oklch(60.38% 0.0978 245.07)"
      },
      "brand.onPrimary": {
        "evidence": [
          "observed-on-primary:pair:rule div#static_content table tbody tr th, table.stylized tbody tr th",
          "contrast:3.85:1"
        ],
        "confidence": 0.92,
        "derived": false,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "brand.primaryHover": {
        "evidence": [
          "observed-hover:cta-background:.membership-join-button:hover occurrences:32",
          "deltaE-from-primary:0.024"
        ],
        "confidence": 0.6,
        "derived": false,
        "value": "#4580af",
        "oklch": "oklch(58.04% 0.0954 244.56)"
      },
      "brand.secondary": {
        "evidence": [
          "cta-background:.membership-join-button occurrences:27",
          "cta-background:.membership-type-button, .membership-close-button occurrences:27",
          "runner-up-to-primary: score=0.65 chroma=0.086 gate=0.99 sources=cta-background+link-color+surface-background+text-color"
        ],
        "confidence": 0.72,
        "derived": false,
        "value": "#2e6089",
        "oklch": "oklch(47.37% 0.0858 245.75)"
      },
      "bg.canvas": {
        "evidence": [
          "canvas:painted-area area=2131200 paint=1 nodes=html.disable--interaction.show--consent == html"
        ],
        "confidence": 0.92,
        "derived": false,
        "value": "#818181",
        "oklch": "oklch(60.32% 0 0)"
      },
      "bg.surface": {
        "evidence": [
          "background:ul area=437760 paint=9",
          "background:div.cm.cm--cloud area=174879 paint=109",
          "surface-weight=0.84 deltaE-from-canvas=0.397 hue-affinity=1.00"
        ],
        "confidence": 0.77,
        "derived": false,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "bg.raised": {
        "evidence": [
          "surface-background:div#trafficreport div.groups p occurrences:8",
          "surface-background:div#trafficreport div.groups ul.categories occurrences:8",
          "surface-weight=0.08 deltaE-from-canvas=0.334 hue-affinity=1.00"
        ],
        "confidence": 0.78,
        "derived": false,
        "value": "#eaeaea",
        "oklch": "oklch(93.7% 0 0)"
      },
      "bg.footer": {
        "evidence": [
          "footer-background:div.cm__footer",
          "success-selector:.cookies-eu .cookies-eu-button-holder .cookies-eu-ok occurrences:167",
          "footer-background weight=0.80"
        ],
        "confidence": 0.95,
        "derived": false,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "fg.default": {
        "evidence": [
          "text-color:div.box_blue_middle_1, div.box_blue_middle_2, div.box_blue_middle_3, d occurrences:167",
          "text-color:div#footer ul.col_1 occurrences:167",
          "text-weight=0.58 contrast-on-canvas=3.90:1"
        ],
        "confidence": 0.91,
        "derived": false,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "fg.muted": {
        "evidence": [
          "text-color:.vjs-menu li.vjs-selected,.vjs-menu li.vjs-selected:focus,.vjs-menu li occurrences:5",
          "cta-background:.video-js .vjs-big-play-button occurrences:5",
          "text-weight=0.00 contrast-on-canvas=3.27:1"
        ],
        "confidence": 0.9,
        "derived": false,
        "value": "rgba(43, 51, 63, 0.7)",
        "oklch": "oklch(31.87% 0.0242 258.36)"
      },
      "fg.onBrand": {
        "evidence": [
          "observed-on-primary:pair:rule div#static_content table tbody tr th, table.stylized tbody tr th",
          "contrast:3.85:1",
          "same as brand.onPrimary"
        ],
        "confidence": 0.92,
        "derived": true,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "border.default": {
        "evidence": [
          "border-color:#lbImage occurrences:167",
          "border-color:#lbBottom occurrences:167",
          "border-weight=0.32 contrast=3.90:1 hue-affinity=1.00"
        ],
        "confidence": 0.69,
        "derived": false,
        "value": "#ffffff",
        "oklch": "oklch(100% 0 0)"
      },
      "accent.premium": {
        "evidence": [
          "derived:no premium/gold/vip selector found; reusing brand.secondary"
        ],
        "confidence": 0.2,
        "derived": true,
        "value": "#2e6089",
        "oklch": "oklch(47.37% 0.0858 245.75)"
      },
      "state.success": {
        "evidence": [
          "success-selector:div#contact p.success occurrences:2",
          "border-color:div#contact p.success occurrences:2",
          "success-hint=0.06 hue=143 chroma=0.118"
        ],
        "confidence": 0.76,
        "derived": false,
        "value": "#125410",
        "oklch": "oklch(39.09% 0.1183 142.56)"
      },
      "state.danger": {
        "evidence": [
          "danger-selector:.ui-state-error, .ui-widget-content .ui-state-error occurrences:4",
          "danger-selector:.ui-state-error a, .ui-widget-content .ui-state-error a occurrences:4",
          "danger-hint=0.18 hue=29 chroma=0.216"
        ],
        "confidence": 0.73,
        "derived": false,
        "value": "#cd0a0a",
        "oklch": "oklch(53.55% 0.2158 28.84)"
      }
    },
    "typography": {
      "families": {
        "sans": {
          "observed": "HelveticaNeue",
          "rendered": "Arial",
          "licensed": false,
          "licenseNote": "HelveticaNeue is proprietary (Monotype/Commercial Type/Swiss Typefaces). Substituted with Inter (neutral grotesque, near-identical x-height). No font binary is rehosted.",
          "substitute": {
            "family": "Inter",
            "source": "google",
            "license": "OFL-1.1",
            "subsets": [
              "latin",
              "latin-ext"
            ],
            "weights": [
              400
            ],
            "metricOverrides": null
          },
          "stack": "Inter, HelveticaNeue, ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif"
        }
      },
      "baseSizePx": 12,
      "baseWeight": 400,
      "headingWeight": 700,
      "scale": {
        "ratio": 1.125,
        "steps": {
          "md": 12,
          "lg": 14,
          "xl": 16
        }
      },
      "case": {
        "heading": "none",
        "button": "none"
      },
      "tracking": {}
    },
    "shape": {
      "radius": {
        "card": 4,
        "control": 6,
        "chip": 999
      },
      "borderWidth": 1
    },
    "elevation": {
      "sm": "rgba(0, 0, 0, 0.2) 0px 2px 4px 0px",
      "md": "rgba(0, 0, 2, 0.3) 0px 10px 30px 0px"
    },
    "density": {
      "spaceBase": 4,
      "scale": [
        0,
        2,
        4,
        6,
        8,
        12,
        16,
        24,
        32
      ]
    },
    "motion": {
      "durationMs": 150,
      "easing": "ease"
    }
  },
  "domain": {
    "entities": {},
    "vocabularies": {}
  },
  "capabilities": [
    {
      "id": "list_items",
      "name": "list_items",
      "title": "List items",
      "description": "List the items published on www.hak.hr. Each result carries li, a. Read live from /, where 15 items were observed. Use this to discover what is available before asking about a specific one.",
      "kind": "read",
      "annotations": {
        "readOnlyHint": true,
        "untrustedContentHint": true
      },
      "inputSchema": {
        "type": "object",
        "properties": {
          "query": {
            "type": "string",
            "description": "Case-insensitive substring filter across li, a"
          },
          "limit": {
            "type": "integer",
            "minimum": 1,
            "maximum": 100,
            "default": 20
          }
        },
        "required": []
      },
      "binding": {
        "type": "pipeline",
        "steps": [
          {
            "as": "rows",
            "optional": false,
            "op": "http.html",
            "url": "https://www.hak.hr/",
            "query": {},
            "headers": {},
            "extract": {
              "$root": ".subnav",
              "li": {
                "sel": "li",
                "as": "trim"
              },
              "a": {
                "sel": "a",
                "as": "trim"
              }
            }
          },
          {
            "as": "rows",
            "optional": false,
            "op": "filter",
            "from": "{{rows}}",
            "where": [
              {
                "field": "li",
                "cmp": "includes",
                "value": "{{query}}",
                "skipIfEmpty": true
              },
              {
                "field": "a",
                "cmp": "includes",
                "value": "{{query}}",
                "skipIfEmpty": true
              }
            ]
          },
          {
            "as": "rows",
            "optional": false,
            "op": "limit",
            "from": "{{rows}}",
            "n": 100
          }
        ],
        "returns": "rows"
      },
      "verified": {
        "at": "2026-08-27T22:15:58.981Z",
        "samples": 1,
        "passRate": 1
      },
      "view": "items_list",
      "surfaces": {
        "web": {
          "register": true
        },
        "app": {
          "register": true,
          "visibility": [
            "model",
            "app"
          ]
        }
      },
      "freshness": {
        "ttlSec": 1800,
        "staleOnError": true,
        "maxStaleSec": 86400
      }
    },
    {
      "id": "list_sigurnost_u_prometus",
      "name": "list_sigurnost_u_prometus",
      "title": "List sigurnost u prometus",
      "description": "List the sigurnost u prometus published on www.hak.hr. Each result carries li, a. Read live from /sigurnost-u-prometu/projekti/ersc, where 15 sigurnost u prometus were observed. Use this to discover what is available before asking about a specific one.",
      "kind": "read",
      "annotations": {
        "readOnlyHint": true,
        "untrustedContentHint": true
      },
      "inputSchema": {
        "type": "object",
        "properties": {
          "query": {
            "type": "string",
            "description": "Case-insensitive substring filter across li, a"
          },
          "limit": {
            "type": "integer",
            "minimum": 1,
            "maximum": 100,
            "default": 20
          }
        },
        "required": []
      },
      "binding": {
        "type": "pipeline",
        "steps": [
          {
            "as": "rows",
            "optional": false,
            "op": "http.html",
            "url": "https://www.hak.hr/sigurnost-u-prometu/projekti/ersc",
            "query": {},
            "headers": {},
            "extract": {
              "$root": ".subnav",
              "li": {
                "sel": "li",
                "as": "trim"
              },
              "a": {
                "sel": "a",
                "as": "trim"
              }
            }
          },
          {
            "as": "rows",
            "optional": false,
            "op": "filter",
            "from": "{{rows}}",
            "where": [
              {
                "field": "li",
                "cmp": "includes",
                "value": "{{query}}",
                "skipIfEmpty": true
              },
              {
                "field": "a",
                "cmp": "includes",
                "value": "{{query}}",
                "skipIfEmpty": true
              }
            ]
          },
          {
            "as": "rows",
            "optional": false,
            "op": "limit",
            "from": "{{rows}}",
            "n": 100
          }
        ],
        "returns": "rows"
      },
      "verified": {
        "at": "2026-08-27T22:15:58.981Z",
        "samples": 1,
        "passRate": 1
      },
      "view": "sigurnost_u_prometus_list",
      "surfaces": {
        "web": {
          "register": true
        },
        "app": {
          "register": true,
          "visibility": [
            "model",
            "app"
          ]
        }
      },
      "freshness": {
        "ttlSec": 1800,
        "staleOnError": true,
        "maxStaleSec": 86400
      }
    },
    {
      "id": "list_vozilas",
      "name": "list_vozilas",
      "title": "List vozilas",
      "description": "List the vozilas published on www.hak.hr. Each result carries li, a. Read live from /vozila/tehnicki-pregledi/popis-stp/, where 15 vozilas were observed. Use this to discover what is available before asking about a specific one.",
      "kind": "read",
      "annotations": {
        "readOnlyHint": true,
        "untrustedContentHint": true
      },
      "inputSchema": {
        "type": "object",
        "properties": {
          "query": {
            "type": "string",
            "description": "Case-insensitive substring filter across li, a"
          },
          "limit": {
            "type": "integer",
            "minimum": 1,
            "maximum": 100,
            "default": 20
          }
        },
        "required": []
      },
      "binding": {
        "type": "pipeline",
        "steps": [
          {
            "as": "rows",
            "optional": false,
            "op": "http.html",
            "url": "https://www.hak.hr/vozila/tehnicki-pregledi/popis-stp/",
            "query": {},
            "headers": {},
            "extract": {
              "$root": ".subnav",
              "li": {
                "sel": "li",
                "as": "trim"
              },
              "a": {
                "sel": "a",
                "as": "trim"
              }
            }
          },
          {
            "as": "rows",
            "optional": false,
            "op": "filter",
            "from": "{{rows}}",
            "where": [
              {
                "field": "li",
                "cmp": "includes",
                "value": "{{query}}",
                "skipIfEmpty": true
              },
              {
                "field": "a",
                "cmp": "includes",
                "value": "{{query}}",
                "skipIfEmpty": true
              }
            ]
          },
          {
            "as": "rows",
            "optional": false,
            "op": "limit",
            "from": "{{rows}}",
            "n": 100
          }
        ],
        "returns": "rows"
      },
      "verified": {
        "at": "2026-08-27T22:15:58.981Z",
        "samples": 1,
        "passRate": 1
      },
      "view": "vozilas_list",
      "surfaces": {
        "web": {
          "register": true
        },
        "app": {
          "register": true,
          "visibility": [
            "model",
            "app"
          ]
        }
      },
      "freshness": {
        "ttlSec": 1800,
        "staleOnError": true,
        "maxStaleSec": 86400
      }
    },
    {
      "id": "list_vijests",
      "name": "list_vijests",
      "title": "List vijests",
      "description": "List the vijests published on www.hak.hr. Each result carries li, a. Read live from /vijest/2425/hak-proslavio-120-godina, where 15 vijests were observed. Use this to discover what is available before asking about a specific one.",
      "kind": "read",
      "annotations": {
        "readOnlyHint": true,
        "untrustedContentHint": true
      },
      "inputSchema": {
        "type": "object",
        "properties": {
          "query": {
            "type": "string",
            "description": "Case-insensitive substring filter across li, a"
          },
          "limit": {
            "type": "integer",
            "minimum": 1,
            "maximum": 100,
            "default": 20
          }
        },
        "required": []
      },
      "binding": {
        "type": "pipeline",
        "steps": [
          {
            "as": "rows",
            "optional": false,
            "op": "http.html",
            "url": "https://www.hak.hr/vijest/2425/hak-proslavio-120-godina",
            "query": {},
            "headers": {},
            "extract": {
              "$root": ".subnav",
              "li": {
                "sel": "li",
                "as": "trim"
              },
              "a": {
                "sel": "a",
                "as": "trim"
              }
            }
          },
          {
            "as": "rows",
            "optional": false,
            "op": "filter",
            "from": "{{rows}}",
            "where": [
              {
                "field": "li",
                "cmp": "includes",
                "value": "{{query}}",
                "skipIfEmpty": true
              },
              {
                "field": "a",
                "cmp": "includes",
                "value": "{{query}}",
                "skipIfEmpty": true
              }
            ]
          },
          {
            "as": "rows",
            "optional": false,
            "op": "limit",
            "from": "{{rows}}",
            "n": 100
          }
        ],
        "returns": "rows"
      },
      "verified": {
        "at": "2026-08-27T22:15:58.981Z",
        "samples": 1,
        "passRate": 1
      },
      "view": "vijests_list",
      "surfaces": {
        "web": {
          "register": true
        },
        "app": {
          "register": true,
          "visibility": [
            "model",
            "app"
          ]
        }
      },
      "freshness": {
        "ttlSec": 1800,
        "staleOnError": true,
        "maxStaleSec": 86400
      }
    }
  ],
  "views": [
    {
      "id": "items_list",
      "layout": "list",
      "title": "Items list",
      "slots": {},
      "badges": [],
      "emptyText": "Nothing matched that request."
    },
    {
      "id": "sigurnost_u_prometus_list",
      "layout": "list",
      "title": "Sigurnost u prometus list",
      "slots": {},
      "badges": [],
      "emptyText": "Nothing matched that request."
    },
    {
      "id": "vozilas_list",
      "layout": "list",
      "title": "Vozilas list",
      "slots": {},
      "badges": [],
      "emptyText": "Nothing matched that request."
    },
    {
      "id": "vijests_list",
      "layout": "list",
      "title": "Vijests list",
      "slots": {},
      "badges": [],
      "emptyText": "Nothing matched that request."
    }
  ],
  "copy": {},
  "policy": {
    "ownership": "third-party",
    "disclaimer": "Unofficial. Not affiliated with, endorsed by, or operated by www.hak.hr. Information is read live from www.hak.hr and every transaction is completed on their own site.",
    "assets": {
      "rehostImages": false,
      "rehostFonts": false,
      "rehostText": false
    },
    "data": {
      "retainHistory": false,
      "maxHorizonDays": 7,
      "maxRps": 0.5
    },
    "deepLinkOnly": true,
    "takedownUrl": "https://clawharbor.io/takedown"
  },
  "contentHash": "sha256:b604d5e9489e97a2365be8877e4c5fa4285cad1945510cea47bd736099da5bb5"
} as unknown as Manifest;
